import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'navigation-buttons',
  template: `<br />
            <div>
              <div class="float-left">
                <button type="button" class="btn btn-primary" (click)="this.back.emit()">{{ 'navigation.backButton' | translate }}</button>
              </div>
              <div class="float-right">
                <button type="button" class="btn btn-primary" [disabled]="disabled" (click)="this.next.emit()">{{ 'navigation.nextButton' | translate }}</button>
              </div>
            </div>
              <br>
              <br>`,
})
export class NavigationButtonsComponent {
  @Input('disabled') disabled = false;
  @Output() back = new EventEmitter();
  @Output() next = new EventEmitter();

  constructor() { }

}
